<template>
    <g id="life-buoy" fill="none">
        <path
            id="Vector"
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            stroke="#606060"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            id="Vector_2"
            d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
            stroke="#606060"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path id="Vector_3" d="M4.93 4.93L9.17 9.17" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path id="Vector_4" d="M14.83 14.83L19.07 19.07" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path id="Vector_5" d="M14.83 9.17L19.07 4.93" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path id="Vector_6" d="M14.83 9.17L18.36 5.64" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path id="Vector_7" d="M4.93 19.07L9.17 14.83" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </g>
</template>
